import React from 'react';
import ConfirmActionType from '../../../model/ConfirmActionType';

export interface ConfirmActionContextType {
  handleAction: (onAction, text: string, actionType: ConfirmActionType) => void;
  confirmAction: () => void;
  cancelAction: () => void;
  confirmationText: string
  visible: boolean;
  confirmActionType: ConfirmActionType;
}

export default React.createContext<ConfirmActionContextType>({
  handleAction: undefined,
  confirmAction: undefined,
  cancelAction: undefined,
  visible: false,
  confirmationText: null,
  confirmActionType: null,
});
